// extracted by mini-css-extract-plugin
export default {"container":"Introduction_container__sLt85","background":"Introduction_background__xDhGi","videos":"Introduction_videos__ZAOgh"};